/**
 * Whether the browser reports the device as offline (`navigator.onLine === false`).
 *
 * Only the offline direction is meaningful, and even that lies: Chrome can pin
 * `onLine` to false (pending update, captive portal) while other requests in
 * the same tab succeed. Do not block a send on this alone (EVI-2557).
 */
export function isBrowserOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}
